import { ToFixedNumber } from "./formatter"

export function volumeLastText(volume: string): string {
  const tmp = Number(volume)
  if (tmp > 1000000000) {
    return (tmp / 1000000000).toFixed(2) + 'B'
  }

  if (tmp > 1000000) {
    return (tmp / 1000000).toFixed(2) + 'M'
  }

  if (tmp > 1000) {
    return (tmp / 1000).toFixed(2) + 'K'
  }

  return tmp.toString()
}

export function fundingFeeText(fee: string): string {
  return (Number(fee) * 100).toFixed(4) + '%'
}

export function roundToUnit(value: number, unit: number = 0.001): number {
  return Math.round(value / unit) * unit
}

// json key 중에서 맥스 가져오는 기능
export const maxJsonColumn = (obj: any[], key: string) => {
  // json column 을  array 로 변경, 이후 max 만 뽑는 방식
  const maxValue = Math.max(...obj.map((item: any) => item[key]))
  return maxValue
}

// 손익만 계산하기
export const unPnl = (entryPrice: number, markPrice: number, size: number, positionSide: string) => {
  const pnl = positionSide === 'LONG' ? (Number(markPrice) - Number(entryPrice)) * Number(size) : (Number(entryPrice) - Number(markPrice)) * Number(size)
  return pnl
}

// 손익 계산하기 !! entryPrice, markPrice, size, positionSide
export const unPnlPersent = (
  entryPrice: number,
  markPrice: number,
  size: number,
  positionSide: string,
  leverage: string,
) => {
  // PnL 계산 - 유효하지 않은 값이면 0 반환
  let pnl = 0
  if (!isNaN(Number(entryPrice)) && !isNaN(Number(markPrice)) && !isNaN(Number(size)) &&
    isFinite(Number(entryPrice)) && isFinite(Number(markPrice)) && isFinite(Number(size))) {
    const calculatedPnl =
      positionSide === 'LONG'
        ? (Number(markPrice) - Number(entryPrice)) * Number(Math.abs(Number(size)))
        : (Number(entryPrice) - Number(markPrice)) * Number(Math.abs(Number(size)))

    if (!isNaN(calculatedPnl) && isFinite(calculatedPnl)) {
      pnl = calculatedPnl
    }
  }

  // 퍼센트 수익률 계산 - entryPrice가 0이거나 유효하지 않은 값이면 0 반환
  let percent = 0
  if (Number(entryPrice) !== 0 && !isNaN(Number(entryPrice)) && isFinite(Number(entryPrice))) {
    const calculatedPercent =
      positionSide === 'LONG'
        ? ((Number(markPrice) - Number(entryPrice)) / Number(entryPrice)) * 100 * Number(leverage)
        : ((Number(entryPrice) - Number(markPrice)) / Number(entryPrice)) * 100 * Number(leverage)

    // 계산 결과가 유효한 숫자인지 확인
    if (!isNaN(calculatedPercent) && isFinite(calculatedPercent)) {
      percent = calculatedPercent
    }
  }

  return [pnl, percent] // PnL과 퍼센트 수익률을 배열로 반환
}

export function m_marginRatio(isolatedMargin: number, notional: number, decimalPlaces: number): string {
  return ((isolatedMargin / Math.abs(Number(notional))) * 100).toFixed(decimalPlaces)
}

// Isolated 일때 작업 처리
export function GetMarginRatio(MarginRatio: number, openPrice: number, isolatedMargin: number) {
  // 마진 정보 계산
  const uma = MarginRatio * openPrice
  // 청산 위험 비율 계산
  const liquidationRiskRatio = (uma / isolatedMargin) * 100
  // 소수점 2자리까지 반환
  return ToFixedNumber(liquidationRiskRatio, 2)
}

// 마진 비율 = (자산 총 가치 - 미체결 주문 가격 + 손익) / (유지 마진)
export const getMarketRadio = (balance: number, userOpenOrderMargin: number, usePositionMargin: number, totalProfit: number) => {
  const tmp = balance - userOpenOrderMargin - usePositionMargin + totalProfit
  const radio = (usePositionMargin / tmp) * 100
  return radio
}
// 가격, 이용가능한 금액, 레버리지, 퍼센트,
// 이용 가능한 수량으로 실제 수량 가져오기
export const getAbleQty = (price: number, abvi: number, lver: number, perset: number): [number, number] => {
  // 실제 이용 가능한 금액 (레버리지 적용)
  const availableWithLeverage = abvi * lver

  const usableAmount = availableWithLeverage * (perset / 100)

  // 구매 가능한 수량 (qty), 약간 낮게 조정 (0.98 곱함)
  let qty = usableAmount / price
  if (perset >= 98) {
    qty = (usableAmount / price) * 0.98
  } else {
    qty = usableAmount / price
  }

  // 구매 가능한 금액 (USDT)와 수량 (qty) 반환
  return [usableAmount, qty]
}

export const getQtyForUSDT = (price: number, usdt: number): number => {
  // 구매 가능한 수량을 계산 (Long/Short 동일)
  const qty = usdt / price
  return qty
}

export function calculateDivisions(countBack: number, maxCnt: number): number {
  return Math.ceil(countBack / maxCnt)
}

export function formatNumberIgnoreDecimals(number: number): string {
  // 소수점 이하 자릿수를 무시하고 정수 부분만 사용
  const integerPart = Math.floor(number)

  // 정수 부분을 천 단위 구분 기호를 추가하여 포맷
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(integerPart)
}

export const countTrailingZeros = (num: number): number => {
  let count = 0
  let numTmp = num
  while (numTmp % 10 === 0 && numTmp !== 0) {
    count++
    numTmp = Math.floor(numTmp / 10)
  }
  return count
}

// 백만단위 절삭 -- 18750.03 M
export const floorMillionDot = (num: number) => {
  return Math.floor(num / 10000) / 100
}

// 백만 단위 이상이면 "M"으로, 천 단위 이상이면 "K"
export const formatLargeNumber = (number: number): string => {
  if (number >= 1_000_000) {
    return (number / 1_000_000).toFixed(1) + 'M'
  } else if (number >= 1_000) {
    return (number / 1_000).toFixed(1) + 'K'
  } else {
    return number.toFixed(4)
  }
}

export const getPower = (tickSize: number): number => {
  const result = Math.pow(10, tickSize)
  return result
}

// 소수점 버림 처리
export const decimalFloor = (num: number | string, decimalPlaces: number = 8): string => {
  const formatNum = Number(num)

  if (isNaN(formatNum)) {
    throw new Error('Invalid number input')
  }

  if (formatNum === 0) return '0'
  const factor = 10 ** decimalPlaces
  const flooredValue = Math.floor(formatNum * factor) / factor
  return flooredValue.toFixed(decimalPlaces)
}
